import { render } from "./UserDetails.vue?vue&type=template&id=408850a3&scoped=true&lang=true"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"

import "./UserDetails.vue?vue&type=style&index=0&id=408850a3&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-408850a3"

export default script